import { render, staticRenderFns } from "./mobilePreview.vue?vue&type=template&id=b6417c34&scoped=true&"
import script from "./mobilePreview.vue?vue&type=script&lang=js&"
export * from "./mobilePreview.vue?vue&type=script&lang=js&"
import style0 from "./mobilePreview.vue?vue&type=style&index=0&id=b6417c34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6417c34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6417c34')) {
      api.createRecord('b6417c34', component.options)
    } else {
      api.reload('b6417c34', component.options)
    }
    module.hot.accept("./mobilePreview.vue?vue&type=template&id=b6417c34&scoped=true&", function () {
      api.rerender('b6417c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mobilePreview.vue"
export default component.exports